// extracted by mini-css-extract-plugin
export default {"cardHeader":"Links_cardHeader__YTkYb"};